import inquiryService from "../services/inquiry.service";
import { toogleErrorMessage, toogleSuccessMessage } from "./alertMessage";
import {
  INQUIRY_DETAIL,
  INQUIRY_DETAIL_ERROR,
  INQUIRY_DETAIL_LOADING,
  INQUIRY_QUOTATION_ERROR,
  INQUIRY_QUOTATION_LOADING,
  INQUIRY_ERROR,
  INQUIRY_LIST,
  INQUIRY_LOADING,
  SECTOR_LIST,
  SECTOR_LOADING,
  SECTOR_ERROR,
  PRODUCT_LIST,
  PRODUCT_REQUEST,
  PRODUCT_LOADING,
  PRODUCT_ERROR,
} from "./type";

const getResponseMessage = (response) =>
  response?.data?.message ||
  response?.data?.data?.message ||
  response?.response?.data?.message ||
  response?.response?.data?.data?.message ||
  response?.message ||
  "";
const getResponseStatus = (response) =>
  response?.status ?? response?.response?.status ?? 0;
const getInquiryListData = (response) => {
  const responseBody = response?.data || {};
  const data = responseBody?.data?.data ?? responseBody?.data ?? responseBody;
  const items = Array.isArray(data)
    ? data
    : data?.inquiries ||
      data?.items ||
      data?.results ||
      data?.list ||
      data?.data ||
      [];
  const pagination =
    data?.pagination ||
    data?.meta ||
    responseBody?.pagination ||
    responseBody?.meta ||
    responseBody?.data?.pagination ||
    {};

  return { responseBody, data, items: Array.isArray(items) ? items : [], pagination };
};

const getInquiryDetailData = (response) => {
  const responseBody = response?.data || {};
  const data =
    responseBody?.data?.data?.inquiry ||
    responseBody?.data?.data?.item ||
    responseBody?.data?.inquiry ||
    responseBody?.data?.item ||
    responseBody?.data?.data ||
    responseBody?.data ||
    responseBody?.inquiry ||
    responseBody?.item ||
    responseBody;

  return Array.isArray(data) ? data[0] || null : data;
};

const getLookupItems = (response, key) => {
  const body = response?.data || {};
  const data = body?.data?.data ?? body?.data ?? body;
  const items = Array.isArray(data)
    ? data
    : data?.[key] || data?.items || data?.results || data?.list || [];
  if (Array.isArray(items)) return items;
  return Array.isArray(items?.data) ? items.data : [];
};

export const getInquiryListAction =
  ({ page = 1, limit = 10, status = "", search = "" } = {}) =>
  async (dispatch) => {
    dispatch({ type: INQUIRY_LOADING, payload: true });

    try {
      const response = await inquiryService.getInquiries({
        page,
        limit,
        status,
        search,
      });

      const responseStatus = getResponseStatus(response);
      if (responseStatus >= 200 && responseStatus < 300) {
        const { responseBody, data, items, pagination } = getInquiryListData(response);
        const summary =
          data?.summary ??
          data?.statistics ??
          data?.stats ??
          data?.counts ??
          data?.statusCounts ??
          responseBody?.summary ??
          responseBody?.statistics ??
          responseBody?.stats ??
          responseBody?.counts ??
          responseBody?.statusCounts ??
          {};
        const pageSize =
          Number(pagination.limit ?? pagination.pageSize ?? pagination.perPage ?? pagination.per_page ?? data?.limit ?? limit) ||
          Number(limit);
        const currentPage =
          Number(
            pagination.page ??
              pagination.currentPage ??
              pagination.current_page ??
              data?.page ??
              page,
          ) || Number(page);
        const reportedTotal =
          pagination.total ??
          pagination.totalCount ??
          pagination.totalItems ??
          pagination.totalRecords ??
          pagination.count ??
          data?.total ??
          data?.totalCount ??
          data?.totalItems ??
          data?.totalRecords ??
          responseBody?.total ??
          responseBody?.totalCount;
        const reportedTotalPages = Number(pagination.totalPages ?? pagination.total_pages ?? pagination.pages ?? data?.totalPages ?? responseBody?.totalPages);
        const total =
          reportedTotal !== undefined && reportedTotal !== null
            ? Number(reportedTotal) || 0
            : reportedTotalPages
              ? Math.max(
                  (reportedTotalPages - 1) * pageSize + items.length,
                  items.length,
                )
              : items.length;

        dispatch({
          type: INQUIRY_LIST,
          payload: {
            items,
            summary,
            pagination: {
              ...pagination,
              page: currentPage,
              limit: pageSize,
              total,
              totalPages:
                Number(pagination.totalPages ?? pagination.total_pages ?? pagination.pages ?? data?.totalPages ?? responseBody?.totalPages) ||
                Math.max(Math.ceil(total / pageSize), 1),
            },
          },
        });
        dispatch({ type: INQUIRY_ERROR, payload: "" });
      } else {
        dispatch({
          type: INQUIRY_ERROR,
          payload: getResponseMessage(response) || "Unable to load inquiries.",
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: INQUIRY_ERROR,
        payload:
          getResponseMessage(error) ||
          error?.message ||
          "Unable to load inquiries.",
      });
      return error;
    } finally {
      dispatch({ type: INQUIRY_LOADING, payload: false });
    }
  };
export const getInquiryAction =
  (id, { preserveData = false } = {}) =>
  async (dispatch) => {
    dispatch({ type: INQUIRY_DETAIL_LOADING, payload: true });
    if (!preserveData) dispatch({ type: INQUIRY_DETAIL, payload: null });
    dispatch({ type: INQUIRY_DETAIL_ERROR, payload: "" });

    try {
      const response = await inquiryService.getInquiry(id);

      if (response?.status >= 200 && response?.status < 300) {
        dispatch({
          type: INQUIRY_DETAIL,
          payload: getInquiryDetailData(response),
        });
      } else {
        dispatch({
          type: INQUIRY_DETAIL_ERROR,
          payload: getResponseMessage(response) || "Unable to load inquiry.",
        });
      }

      return response;
    } catch (error) {
      dispatch({
        type: INQUIRY_DETAIL_ERROR,
        payload:
          getResponseMessage(error) ||
          error?.message ||
          "Unable to load inquiry.",
      });
      return error;
    } finally {
      dispatch({ type: INQUIRY_DETAIL_LOADING, payload: false });
    }
  };

export const createInquiryQuotationAction =
  (id, payload) =>
  async (dispatch) => {
    dispatch({ type: INQUIRY_QUOTATION_LOADING, payload: true });
    dispatch({ type: INQUIRY_QUOTATION_ERROR, payload: "" });

    try {
      const response = await inquiryService.createInquiryQuotation(id, payload);
      const status = getResponseStatus(response);
      const message = getResponseMessage(response);

      if (status >= 200 && status < 300) {
        toogleSuccessMessage(message || "Quotation submitted successfully.");
        return { success: true, response };
      }

      const errorMessage =
        message || "Unable to submit your quotation. Please try again.";
      dispatch({ type: INQUIRY_QUOTATION_ERROR, payload: errorMessage });
      toogleErrorMessage(errorMessage);
      return { success: false, response };
    } catch (error) {
      const errorMessage =
        getResponseMessage(error) ||
        error?.message ||
        "Unable to submit your quotation. Please try again.";
      dispatch({ type: INQUIRY_QUOTATION_ERROR, payload: errorMessage });
      toogleErrorMessage(errorMessage);
      return { success: false, error };
    } finally {
      dispatch({ type: INQUIRY_QUOTATION_LOADING, payload: false });
    }
  };

export const getClientSectorsAction = () => async (dispatch) => {
  dispatch({ type: SECTOR_LOADING, payload: true });
  dispatch({ type: SECTOR_ERROR, payload: "" });
  try {
    const response = await inquiryService.getClientSectors();
    if (response?.status >= 200 && response?.status < 300) {
      dispatch({ type: SECTOR_LIST, payload: getLookupItems(response, "sectors") });
    } else {
      dispatch({
        type: SECTOR_ERROR,
        payload: getResponseMessage(response) || "Unable to load sectors.",
      });
    }
    return response;
  } finally {
    dispatch({ type: SECTOR_LOADING, payload: false });
  }
};

let productsRequestId = 0;

export const getClientProductsAction = (params) => async (dispatch, getState) => {
  const requestId = ++productsRequestId;
  dispatch({
    type: PRODUCT_REQUEST,
    payload: { requestId, sector: params?.sector },
  });
  dispatch({ type: PRODUCT_LIST, payload: [] });
  dispatch({ type: PRODUCT_LOADING, payload: true });
  dispatch({ type: PRODUCT_ERROR, payload: "" });
  try {
    const response = await inquiryService.getClientProducts(params);
    if (getState().inquiry.productRequestId !== requestId) return response;
    if (response?.status >= 200 && response?.status < 300) {
      dispatch({ type: PRODUCT_LIST, payload: getLookupItems(response, "products") });
    } else {
      dispatch({
        type: PRODUCT_ERROR,
        payload: getResponseMessage(response) || "Unable to load products.",
      });
    }
    return response;
  } finally {
    if (getState().inquiry.productRequestId === requestId) {
      dispatch({ type: PRODUCT_LOADING, payload: false });
    }
  }
};
export const createRequestQuoteAction = (payload) => async () => {
  const response = await inquiryService.createRequestQuote(payload);
  const message = getResponseMessage(response);
  if (response?.status >= 200 && response?.status < 300) {
    if (message) toogleSuccessMessage(message);
  } else if (message) {
    toogleErrorMessage(message);
  }
  return response;
};

export const uploadCompanyDocumentAction = (file) => async () => {
  const response = await inquiryService.uploadCompanyDocument(file);
  const message = getResponseMessage(response);
  if (response?.status >= 200 && response?.status < 300) {
    if (message) toogleSuccessMessage(message);
  } else if (message) {
    toogleErrorMessage(message);
  }
  return response;
};
